import { createAction } from 'redux-actions';

import { generateApiActions } from './action-helpers';

const types = {
  FETCH_CONTACTS: 'FETCH_CONTACTS',
  SEARCH_CONTACTS: 'SEARCH_CONTACTS',
  FETCH_CONTACT_THREADS: 'FETCH_CONTACT_THREADS',
  FETCH_CONTACT_THREAD_MESSAGES: 'FETCH_CONTACT_THREAD_MESSAGES',
  FETCH_CONTACT_SUCCESS: 'FETCH_CONTACT_SUCCESS',
  CREATE_CONTACT: 'CREATE_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACT: 'UPDATE_CONTACT',
  UPDATE_CONTACT_REQUESTS: 'UPDATE_CONTACT_REQUESTS',
  SET_OPEN_CONTACT: 'SET_OPEN_CONTACT',
  SET_OPEN_CONTACT_REQUEST: 'SET_OPEN_CONTACT_REQUEST',
  RESET_SEARCH_DATA: 'RESET_SEARCH_DATA',
  SET_CONTACT_PAGE: 'SET_CONTACT_PAGE',
  SET_CONTACT_FILTER: 'SET_CONTACT_FILTER',
  RESET_CONTACT_FILTER: 'RESET_CONTACT_FILTER',
  SET_OPEN_CONTACT_THREAD: 'SET_OPEN_CONTACT_THREAD',
  RESET_THREAD_PAGES: 'RESET_THREAD_PAGES',
  DELETE_CONTACT_THREAD: 'DELETE_CONTACT_THREAD',
};

export const {
  fetchContactsRequest,
  fetchContactsSuccess,
  fetchContactsFailure,
} = generateApiActions(types.FETCH_CONTACTS);

export const {
  searchContactsRequest,
  searchContactsSuccess,
  searchContactsFailure,
} = generateApiActions(types.SEARCH_CONTACTS);

export const {
  fetchContactThreadsRequest,
  fetchContactThreadsSuccess,
  fetchContactThreadsFailure,
} = generateApiActions(types.FETCH_CONTACT_THREADS);

export const {
  fetchContactThreadMessagesRequest,
  fetchContactThreadMessagesSuccess,
  fetchContactThreadMessagesFailure,
} = generateApiActions(types.FETCH_CONTACT_THREAD_MESSAGES);

export const {
  createContactRequest,
  createContactSuccess,
  createContactFailure,
} = generateApiActions(types.CREATE_CONTACT);

export const {
  updateContactRequest,
  updateContactSuccess,
  updateContactFailure,
} = generateApiActions(types.UPDATE_CONTACT);

export const {
  deleteContactRequest,
  deleteContactSuccess,
  deleteContactFailure,
} = generateApiActions(types.DELETE_CONTACT);

export const fetchContactSuccess = createAction(types.FETCH_CONTACT_SUCCESS);

export const updateContactRequests = createAction(types.UPDATE_CONTACT_REQUESTS);

export const setOpenContact = createAction(types.SET_OPEN_CONTACT);
export const setOpenContactRequest = createAction(types.SET_OPEN_CONTACT_REQUEST);

export const setPage = createAction(types.SET_CONTACT_PAGE);

export const resetSearchDataContacts = createAction(types.RESET_SEARCH_DATA);

export const setFilter = createAction(types.SET_CONTACT_FILTER);
export const resetFilters = createAction(types.RESET_CONTACT_FILTER);

export const resetThreadPages = createAction(types.RESET_THREAD_PAGES);
export const setOpenContactThread = createAction(types.SET_OPEN_CONTACT_THREAD);
export const deleteContactThreadSuccess = createAction(types.DELETE_CONTACT_THREAD);



// WEBPACK FOOTER //
// ./src/redux/actions/contacts.js